import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import NavBar from "../NavBar";
import { useNavigate } from "react-router-dom";
import StudentProfile from "./StudentProfile";
import StudentInfo from "./StudentInfoProfile";
import { notify_error } from "../Notify";
import { serverAddress } from "../../constant";

const InternationalLawProfile = () => {
  const { id } = useParams();
  const [data, setData] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const styleElement = document.createElement("style");
    styleElement.innerHTML = `
      .custom-sidebar::-webkit-scrollbar { display: none; }
      .custom-sidebar { -ms-overflow-style: none; scrollbar-width: none; }
    `;
    document.head.appendChild(styleElement);
    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  const fetchUserData = async (id) => {
    try {
      const response = await fetch(`${serverAddress}/law-conference-2025/get-one/${id}`);
      if (!response.ok) {
        throw new Error("Failed to fetch user data");
      }
      const result = await response.json();
      setData(result);
    } catch (err) {
      notify_error(err.message || "Something Went Wrong");
    }
  };

  useEffect(() => {
    if (id) {
      fetchUserData(id);
    }
  }, [id]);

  return (
    <div
      className="container-fluid page-body-wrapper"
      style={{
        fontFamily: "Inter",
        position: "relative",
        height: "100vh",
        display: "flex",
      }}
    >
      <NavBar />
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
          padding: "20px",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "128px",
            left: "-27px",
            zIndex: "90",
          }}
        >
          <button
            style={{
              border: "none",
              background: "transparent",
              borderRadius: "50%",
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              navigate("/dashboard/international-law-seminar");
            }}
          >
            <img
              width={"36px"}
              height={"36px"}
              src="/assets/images/dashboard/back-button.png"
              alt="Back"
            />
          </button>
        </div>

        <div
          style={{
            display: "flex",
            flex: 1,
          }}
        >
          <div style={{ flex: "0 0 25%" }}>
            {" "}
            <StudentProfile data={data} />
          </div>
          <div style={{ flex: "0 0 75%" }}>
            {" "}
            <StudentInfo data={data} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InternationalLawProfile;
